import { css, html, LitEntity, renderIf, SirenActionMixin } from '../../utility/lit-entity';
import { sharedStyles } from '../../styles/shared-styles';
import './import-csv-headers';
import './import-csv-upload-button';
import './import-csv-upload';
import './import-errors';
import './import-warnings';

class ImportCsv extends SirenActionMixin(LitEntity) {
  static get properties() {
    return {
      file: { type: Object, attribute: false },
      uploading: { type: Boolean, attribute: false },
    };
  }

  static get styles() {
    return [sharedStyles, css`
      .main-container {
        display: flex;
        justify-content: space-between;
      }
      a {
        white-space: nowrap;
      }
      .hidden {
        display: none;
      }
      .item-count {
        font-weight: bold;
        font-size: 1.2em;
      }
      .header-container {
        display: flex;
      }
      .header {
        flex-grow: 1;
      }
      import-csv-upload-button {
        margin-top: 0.5em;
      }
      .revalidate-button {
        margin-top: 0.5em;
        float: right;
      }
      bn-surface {
        margin: 0;
      }
    `];
  }

  render() {
    const { name, recordCount } = this.entity.properties;

    return html`
      <div class="header-container">
        <h2 class="header">CSV File</h2>
        ${renderIf(this.getCsvUploadAction || this.uploading, () => html`
          <import-csv-upload-button
            .href="${this.href}"
            @file-selected="${this._onFileSelected}"
            ?disabled="${this.uploading}"
          >${this.csvFileEntity ? 'Upload New CSV File' : 'Upload CSV File'}</import-csv-upload-button>
        `)}
      </div>
      <bn-surface>
        <div class="main-container">
          <div>
            ${renderIf(recordCount && !this.uploading, () => html`
              <h3>${name}</h3>
              <label>Record Count:</label>
              <span class="item-count">${recordCount}</span>
            `)}
          </div>
          <div>
            ${renderIf(!this.uploading && this.csvFileEntity, () => html`
              <a href="${this.csvFileEntity.href}">Download Current File</a>
            `)}
            ${renderIf(!this.uploading && this.revalidateImportAction, () => html`
              <bn-action
                class="revalidate-button"
                .href="${this.href}"
                suppressflash
                suppressheader
                actionname="revalidate-import"
                submittext="Re-Validate"
              ></bn-action>
            `)}
          </div>
        </div>
        <div class="${this.uploading ? '' : 'hidden'}">
          <import-csv-upload
            .href="${this.href}"
            @upload-start="${this._onUploadStart}"
            @upload-complete="${this._onUploadComplete}"
            @upload-error="${this._onUploadError}"
          ></import-csv-upload>
        </div>
        ${renderIf(!this.uploading, () => html`
          <import-errors .entity="${this.entity}"></import-errors>
          <import-warnings .entity="${this.entity}"></import-warnings>
        `)}
      </bn-surface>
    `;
  }

  async _onFileSelected(e) {
    this.file = e.detail.file;
    const csvUpload = this.shadowRoot.querySelector('import-csv-upload');
    return csvUpload.uploadCsv(this.file);
  }

  _onUploadStart() {
    this.dispatchEvent(new CustomEvent('upload-start'));
    this.uploading = true;
  }

  _onUploadComplete() {
    this.dispatchEvent(new CustomEvent('upload-complete'));
    this.uploading = false;
  }

  _onUploadError(e) {
    this.dispatchEvent(new ErrorEvent('upload-error', { error: html`Failed to upload file. <pre>${e.error}</pre>` }));
    this.uploading = false;
  }

  _entityChanged(entity) {
    super._entityChanged(entity);
    if (!this.entity) {
      return;
    }
    this.getCsvUploadAction = this.entity.getActionByName('get-csv-upload');
    this.revalidateImportAction = this.entity.getActionByName('revalidate-import');
    this.csvFileEntity = this.entity.getSubEntity('https://api.binsentry.com/rel/csv-file');
  }
}

window.customElements.define('import-csv', ImportCsv);
